// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cb-user-info-section {
  display: flex;
  flex-direction: row;
  align-self: center;
  align-items: center;
  width: var(--cb-container-wide-width);
  height: 1.9rem;
  border: 1px solid #999;
  border-radius: var(--cb-border-radius-sm);
}

.cb-user-info-section-left {
  flex: 1;
  padding-left: 0.5rem;
  height: 1rem;
}

.cb-user-info-section-left-icon {
  height: 1.1rem;
}

.cb-user-info-section-middle {
  flex: 10;
  text-align: center;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.cb-user-info-section-right {
  flex: 1;
  height: 1.2rem;
  padding-right: 0.25rem;
}

.cb-user-info-section-right-icon {
  height: 1.1rem;
  cursor: pointer;
}

.cb-edit-data-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.cb-edit-data-section-header {
  margin-bottom: 1rem;
}

.cb-edit-data-section-back-button {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: var(--cb-font-weight-normal);
}

.cb-otp-input {
  height: 3.25rem;
  border: 1px solid var(--cb-border-color);
  border-radius: var(--cb-border-radius-sm);
  font-size: calc(var(--cb-base-font-size) * 1.25);
  text-align: center;
  font-family: var(--cb-secondary-font);
  padding: 0;
  overflow: hidden;
  width: var(--cb-container-full-width);
}

.cb-otp-input:disabled {
  background-color: var(--cb-otp-disabled-color);
}

.cb-otp-input-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  margin-top: 0.5rem;
  align-self: center;
}

.cb-pk-append {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.cb-pk-append-header {
  text-align: center;
}

.cb-pk-append-icons-section {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.cb-pk-append-icons-section-icon {
  height: 3.75rem;
}

.cb-pk-append-user-info-section {
  display: flex;
  align-items: center;
  align-self: center;
  margin: 0.75rem 0 0.3rem 0;
}

.cb-pk-append-user-info-section-edit-icon {
  height: var(--cb-base-font-size);
  cursor: pointer;
  padding-left: 0.25rem;
}

.cb-pk-append-points-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1.25rem 0 1.75rem 0;
  width: var(--cb-container-standard-width);
  align-self: center;
}

.cb-pk-append-points-section-point {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.cb-pk-append-points-section-point-icon {
  height: 1.5rem;
  margin: auto;
  flex: 0 0 10%;
  max-width: 10%;
}

.cb-pk-append-subtext {
  margin-top: 0.25rem;
  text-align: center;
  align-self: center;
}

.cb-pk-append-buttons-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  margin: 0rem 0 1rem 0;
}

.cb-pk-append-skip-button-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  margin: 1rem 0 1rem 0;
}

.cb-pk-error {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.cb-pk-error-light-header {
  width: var(--cb-container-medium-width);
}

.cb-pk-error-bloc-icons-section {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  margin: 1.75rem auto 1.25rem;
}

.cb-pk-error-bloc-icons-section-icon {
  height: 3.75rem;
}

.cb-pk-error-bloc-icon {
  width: 6rem;
  margin: 2rem auto 0.5rem auto;
}

.cb-pk-error-light-description {
  margin: 1rem auto 0.75rem;
  width: var(--cb-container-standard-width);
  text-align: center;
}

.cb-pk-error-bloc-description {
  margin-bottom: 1.5rem;
  width: var(--cb-container-wide-width);
  text-align: center;
}

.cb-pk-error-light-divider {
  width: var(--cb-container-wide-width);
  margin: 0.6rem auto 0.3rem;
}

.cb-pk-error-bloc-divider {
  width: var(--cb-container-wide-width);
  margin-bottom: 0.3rem;
}

.cb-pk-error-bloc-skip-button {
  display: block;
  margin-top: 1rem;
}

.cb-pk-error-user-info-edit-section {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  text-align: center;
  margin-bottom: 1.25rem;
  margin-top: 1.5rem;
  width: var(--cb-container-full-width);
}

.cb-pk-appended-bloc {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin: 1rem 0 3rem 0;
}

.cb-pk-appended-bloc-icon {
  width: 6rem;
  margin: 0.5rem auto 0.5rem auto;
}

.cb-pk-appended-bloc-description {
  margin-bottom: 2.5rem;
  text-align: center;
}

.cb-pk-hybrid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.cb-pk-hybrid-prompt {
  margin: 1.1rem auto;
}

.cb-pk-hybrid-icon {
  width: 10rem;
}

.cb-pk-hybrid-verification-methods-section {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  text-align: center;
  margin-bottom: 0.8rem;
  margin-top: 0.8rem;
  width: 80%;
}

.cb-pk-hybrid-divider {
  width: 90%;
  margin: 1rem auto;
}

.cb-email-block {
  width: var(--cb-container-wide-width);
  margin-bottom: 1.5rem;
  align-self: center;
}

.cb-email-block-header {
  display: block;
}

.cb-email-user-info-section {
  width: var(--cb-container-full-width);
  margin-top: 2.25rem;
  margin-bottom: 1.75rem;
}

.cb-email-otp-buton-group {
  align-self: center;
  margin: 2rem 0 1.25rem 0;
}

.cb-email-block-user-info-left-icon {
  width: 1.4rem;
}

.cb-email-link-buton-group {
  align-self: center;
  margin: 0.6rem 0 1.75rem 0;
}

.cb-email-links {
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  justify-content: space-around;
}

.cb-email-link {
  justify-content: center;
  width: var(--cb-container-full-width);
}

.cb-email-link img {
  height: 1.25rem;
}

button.cb-email-resend-button {
  width: var(--cb-container-full-width);
  margin-top: 0.2rem;
}

.cb-email-link-success-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  align-self: center;
  text-align: center;
  margin-bottom: 1rem;
}

.cb-email-link-success-subheader {
  display: block;
  width: var(--cb-container-medium-width);
}

.cb-email-link-success-icon-container {
  padding: 0.4rem 2rem;
  border: 1px solid var(--cb-border-color);
  border-radius: var(--cb-border-radius-lg);
  margin-top: 1rem;
  margin-bottom: 1.75rem;
}

.cb-email-link-success-icon {
  height: 2.5rem;
}

.cb-email-link-error-block {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  align-self: center;
  text-align: center;
  margin-bottom: 0.25rem;
  width: 80%;
}

.cb-email-link-error-subheader {
  display: block;
  width: var(--cb-container-wide-width);
}

.cb-email-link-error-icon-container {
  padding: 0.75rem 2.2rem;
  border-radius: var(--cb-border-radius-lg);
  border: 1px solid var(--cb-border-color);
  margin: 1rem auto;
}

.cb-email-link-error-icon {
  height: 1.75rem;
  width: 1.9rem;
}

.cb-email-link-verification-block {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  align-items: center;
  align-self: center;
  text-align: center;
  margin-bottom: 3rem;
}

.cb-email-link-verification-spinner {
  border-top-color: var(--cb-primary-color);
  border-right-color: var(--cb-primary-color);
  width: 3.5rem;
  height: 3.5rem;
  margin-top: 1.25rem;
}

.cb-phone-otp-block {
  width: var(--cb-container-wide-width);
  margin-bottom: 1.5rem;
  align-self: center;
}

.cb-phone-otp-block-header {
  display: block;
}

.cb-phone-otp-user-info-section {
  width: var(--cb-container-full-width);
  margin-top: 2.5rem;
  margin-bottom: 1.75rem;
}

.cb-phone-otp-input-container {
  margin-bottom: 2rem;
}

button.cb-phone-otp-resend-button {
  width: var(--cb-container-full-width);
  margin-top: 0.2rem;
}

.cb-pk-verify {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.cb-pk-verify-header {
  text-align: center;
}

.cb-pk-verify-icons-section {
  display: flex;
  gap: 1.2rem;
  justify-content: center;
  margin-top: 1.5rem;
}

.cb-pk-verify-icons-section-icon {
  height: 3.75rem;
}

.cb-pk-verify-body-section {
  display: flex;
  flex-direction: column;
  margin: 2.5rem auto 2rem;
  gap: 0.5rem;
  width: 60%;
  text-align: center;
  align-self: center;
}

.cb-pk-verify-spinner {
  border-top-color: var(--cb-primary-color);
  border-right-color: var(--cb-primary-color);
  width: 2rem;
  height: 2rem;
  margin: 1rem auto;
}

.cb-pk-verify-fallbacks {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-self: center;
  margin: 1.25rem auto 1rem;
}

.cb-pk-append-after-hybrid,
.cb-pk-append-after-error {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.cb-pk-append-after-hybrid-icon,
.cb-pk-append-after-error-icon {
  width: 6rem;
  margin: 1.2rem auto;
}

.cb-pk-append-after-hybrid-description,
.cb-pk-append-after-error-description {
  display: flex;
  flex-direction: row;
  gap: 0.7rem;
  margin-bottom: 1.5rem;
  width: 90%;
  align-self: center;
}

.cb-pk-append-after-hybrid-description-icon,
.cb-pk-append-after-error-description-icon {
  height: 1.5rem;
  margin: auto;
  flex: 0 0 10%;
  max-width: 10%;
}

.cb-pk-append-after-hybrid-button,
.cb-pk-append-after-error-button {
  display: flex;
  flex-direction: column;
  margin: 0.8rem auto;
}

.cb-login-init {
  display: flex;
  flex-direction: column;
}

.cb-social-login-divider {
  margin: 0 0 0.75rem 0;
}

.cb-social-login-buttons-section {
  display: flex;
  gap: 0.75rem;
  justify-content: space-around;
  width: var(--cb-container-wide-width);
  align-self: center;
  margin-bottom: 1rem;
}

.cb-social-login-buttons-section-large {
  flex-direction: column;
}

.cb-social-login-buttons-section-small {
  flex-direction: row;
}

.cb-social-login-buttton-large img {
  height: 1.25rem;
  padding-right: 0.25rem;
}

.cb-social-login-button-loading-spinner {
  border-top-color: var(--cb-primary-color);
  border-right-color: var(--cb-primary-color);
  width: 0.9rem;
  height: 0.9rem;
}

.cb-last-identifier {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  border-radius: var(--cb-border-radius-sm);
  border: var(--cb-border-color) 1px solid;
  margin: 0.75rem 0;
  padding: 0.6rem 0.5rem 0.6rem 1rem;
  align-self: center;
  cursor: pointer;
  width: var(--cb-container-standard-width);
}

.cb-last-identifier:hover {
  background-color: var(--cb-box-color-hover);
}

.cb-last-identifier-disabled {
  cursor: default;
  background-color: var(--cb-box-color-hover);
}

.cb-last-identifier-icon {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.cb-last-identifier-icon img {
  width: 2rem;
  height: 2rem;
}

.cb-last-identifier-details {
  flex: 5;
  display: flex;
  flex-direction: column;
  justify-content: left;
  line-height: normal;
  gap: 0.35rem;
  white-space: nowrap;
  overflow: hidden;
}

.cb-last-identifier-spinner {
  border-top-color: var(--cb-text-primary-color);
  border-right-color: var(--cb-text-primary-color);
  border-left-color: var(--cb-text-primary-color);
  width: 1.5rem;
  height: 1.5rem;
  box-sizing: border-box;
}

.cb-last-identifier-value-text {
  overflow: hidden;
  text-overflow: ellipsis;
}

.cb-last-identifier-skip-button {
  margin: 0.5rem auto 0.75rem auto;
  width: var(--cb-container-wide-width);
}

@media screen and (max-width: 399px) {
  .cb-pk-error-light-header {
    width: var(--cb-container-standard-width);
  }
}

@media screen and (max-width: 360px) {
  .cb-otp-input-container {
    gap: 0.5rem;
  }

  .cb-otp-input {
    height: 2.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/corbado-auth.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,yCAAyC;EACzC,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,UAAU;EACV,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,wCAAwC;EACxC,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,+CAA+C;EAC/C,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".cb-user-info-section {\n  display: flex;\n  flex-direction: row;\n  align-self: center;\n  align-items: center;\n  width: var(--cb-container-wide-width);\n  height: 1.9rem;\n  border: 1px solid #999;\n  border-radius: var(--cb-border-radius-sm);\n}\n\n.cb-user-info-section-left {\n  flex: 1;\n  padding-left: 0.5rem;\n  height: 1rem;\n}\n\n.cb-user-info-section-left-icon {\n  height: 1.1rem;\n}\n\n.cb-user-info-section-middle {\n  flex: 10;\n  text-align: center;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.cb-user-info-section-right {\n  flex: 1;\n  height: 1.2rem;\n  padding-right: 0.25rem;\n}\n\n.cb-user-info-section-right-icon {\n  height: 1.1rem;\n  cursor: pointer;\n}\n\n.cb-edit-data-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.cb-edit-data-section-header {\n  margin-bottom: 1rem;\n}\n\n.cb-edit-data-section-back-button {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  font-weight: var(--cb-font-weight-normal);\n}\n\n.cb-otp-input {\n  height: 3.25rem;\n  border: 1px solid var(--cb-border-color);\n  border-radius: var(--cb-border-radius-sm);\n  font-size: calc(var(--cb-base-font-size) * 1.25);\n  text-align: center;\n  font-family: var(--cb-secondary-font);\n  padding: 0;\n  overflow: hidden;\n  width: var(--cb-container-full-width);\n}\n\n.cb-otp-input:disabled {\n  background-color: var(--cb-otp-disabled-color);\n}\n\n.cb-otp-input-container {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: center;\n  margin-top: 0.5rem;\n  align-self: center;\n}\n\n.cb-pk-append {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n}\n\n.cb-pk-append-header {\n  text-align: center;\n}\n\n.cb-pk-append-icons-section {\n  display: flex;\n  gap: 1.2rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n\n.cb-pk-append-icons-section-icon {\n  height: 3.75rem;\n}\n\n.cb-pk-append-user-info-section {\n  display: flex;\n  align-items: center;\n  align-self: center;\n  margin: 0.75rem 0 0.3rem 0;\n}\n\n.cb-pk-append-user-info-section-edit-icon {\n  height: var(--cb-base-font-size);\n  cursor: pointer;\n  padding-left: 0.25rem;\n}\n\n.cb-pk-append-points-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin: 1.25rem 0 1.75rem 0;\n  width: var(--cb-container-standard-width);\n  align-self: center;\n}\n\n.cb-pk-append-points-section-point {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n\n.cb-pk-append-points-section-point-icon {\n  height: 1.5rem;\n  margin: auto;\n  flex: 0 0 10%;\n  max-width: 10%;\n}\n\n.cb-pk-append-subtext {\n  margin-top: 0.25rem;\n  text-align: center;\n  align-self: center;\n}\n\n.cb-pk-append-buttons-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  margin: 0rem 0 1rem 0;\n}\n\n.cb-pk-append-skip-button-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n  margin: 1rem 0 1rem 0;\n}\n\n.cb-pk-error {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.cb-pk-error-light-header {\n  width: var(--cb-container-medium-width);\n}\n\n.cb-pk-error-bloc-icons-section {\n  display: flex;\n  gap: 1.2rem;\n  justify-content: center;\n  margin: 1.75rem auto 1.25rem;\n}\n\n.cb-pk-error-bloc-icons-section-icon {\n  height: 3.75rem;\n}\n\n.cb-pk-error-bloc-icon {\n  width: 6rem;\n  margin: 2rem auto 0.5rem auto;\n}\n\n.cb-pk-error-light-description {\n  margin: 1rem auto 0.75rem;\n  width: var(--cb-container-standard-width);\n  text-align: center;\n}\n\n.cb-pk-error-bloc-description {\n  margin-bottom: 1.5rem;\n  width: var(--cb-container-wide-width);\n  text-align: center;\n}\n\n.cb-pk-error-light-divider {\n  width: var(--cb-container-wide-width);\n  margin: 0.6rem auto 0.3rem;\n}\n\n.cb-pk-error-bloc-divider {\n  width: var(--cb-container-wide-width);\n  margin-bottom: 0.3rem;\n}\n\n.cb-pk-error-bloc-skip-button {\n  display: block;\n  margin-top: 1rem;\n}\n\n.cb-pk-error-user-info-edit-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  text-align: center;\n  margin-bottom: 1.25rem;\n  margin-top: 1.5rem;\n  width: var(--cb-container-full-width);\n}\n\n.cb-pk-appended-bloc {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n  margin: 1rem 0 3rem 0;\n}\n\n.cb-pk-appended-bloc-icon {\n  width: 6rem;\n  margin: 0.5rem auto 0.5rem auto;\n}\n\n.cb-pk-appended-bloc-description {\n  margin-bottom: 2.5rem;\n  text-align: center;\n}\n\n.cb-pk-hybrid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1.5rem;\n}\n\n.cb-pk-hybrid-prompt {\n  margin: 1.1rem auto;\n}\n\n.cb-pk-hybrid-icon {\n  width: 10rem;\n}\n\n.cb-pk-hybrid-verification-methods-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  text-align: center;\n  margin-bottom: 0.8rem;\n  margin-top: 0.8rem;\n  width: 80%;\n}\n\n.cb-pk-hybrid-divider {\n  width: 90%;\n  margin: 1rem auto;\n}\n\n.cb-email-block {\n  width: var(--cb-container-wide-width);\n  margin-bottom: 1.5rem;\n  align-self: center;\n}\n\n.cb-email-block-header {\n  display: block;\n}\n\n.cb-email-user-info-section {\n  width: var(--cb-container-full-width);\n  margin-top: 2.25rem;\n  margin-bottom: 1.75rem;\n}\n\n.cb-email-otp-buton-group {\n  align-self: center;\n  margin: 2rem 0 1.25rem 0;\n}\n\n.cb-email-block-user-info-left-icon {\n  width: 1.4rem;\n}\n\n.cb-email-link-buton-group {\n  align-self: center;\n  margin: 0.6rem 0 1.75rem 0;\n}\n\n.cb-email-links {\n  display: flex;\n  flex-direction: row;\n  gap: 0.3rem;\n  justify-content: space-around;\n}\n\n.cb-email-link {\n  justify-content: center;\n  width: var(--cb-container-full-width);\n}\n\n.cb-email-link img {\n  height: 1.25rem;\n}\n\nbutton.cb-email-resend-button {\n  width: var(--cb-container-full-width);\n  margin-top: 0.2rem;\n}\n\n.cb-email-link-success-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  align-self: center;\n  text-align: center;\n  margin-bottom: 1rem;\n}\n\n.cb-email-link-success-subheader {\n  display: block;\n  width: var(--cb-container-medium-width);\n}\n\n.cb-email-link-success-icon-container {\n  padding: 0.4rem 2rem;\n  border: 1px solid var(--cb-border-color);\n  border-radius: var(--cb-border-radius-lg);\n  margin-top: 1rem;\n  margin-bottom: 1.75rem;\n}\n\n.cb-email-link-success-icon {\n  height: 2.5rem;\n}\n\n.cb-email-link-error-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  align-self: center;\n  text-align: center;\n  margin-bottom: 0.25rem;\n  width: 80%;\n}\n\n.cb-email-link-error-subheader {\n  display: block;\n  width: var(--cb-container-wide-width);\n}\n\n.cb-email-link-error-icon-container {\n  padding: 0.75rem 2.2rem;\n  border-radius: var(--cb-border-radius-lg);\n  border: 1px solid var(--cb-border-color);\n  margin: 1rem auto;\n}\n\n.cb-email-link-error-icon {\n  height: 1.75rem;\n  width: 1.9rem;\n}\n\n.cb-email-link-verification-block {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  align-items: center;\n  align-self: center;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.cb-email-link-verification-spinner {\n  border-top-color: var(--cb-primary-color);\n  border-right-color: var(--cb-primary-color);\n  width: 3.5rem;\n  height: 3.5rem;\n  margin-top: 1.25rem;\n}\n\n.cb-phone-otp-block {\n  width: var(--cb-container-wide-width);\n  margin-bottom: 1.5rem;\n  align-self: center;\n}\n\n.cb-phone-otp-block-header {\n  display: block;\n}\n\n.cb-phone-otp-user-info-section {\n  width: var(--cb-container-full-width);\n  margin-top: 2.5rem;\n  margin-bottom: 1.75rem;\n}\n\n.cb-phone-otp-input-container {\n  margin-bottom: 2rem;\n}\n\nbutton.cb-phone-otp-resend-button {\n  width: var(--cb-container-full-width);\n  margin-top: 0.2rem;\n}\n\n.cb-pk-verify {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n}\n\n.cb-pk-verify-header {\n  text-align: center;\n}\n\n.cb-pk-verify-icons-section {\n  display: flex;\n  gap: 1.2rem;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n\n.cb-pk-verify-icons-section-icon {\n  height: 3.75rem;\n}\n\n.cb-pk-verify-body-section {\n  display: flex;\n  flex-direction: column;\n  margin: 2.5rem auto 2rem;\n  gap: 0.5rem;\n  width: 60%;\n  text-align: center;\n  align-self: center;\n}\n\n.cb-pk-verify-spinner {\n  border-top-color: var(--cb-primary-color);\n  border-right-color: var(--cb-primary-color);\n  width: 2rem;\n  height: 2rem;\n  margin: 1rem auto;\n}\n\n.cb-pk-verify-fallbacks {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  align-self: center;\n  margin: 1.25rem auto 1rem;\n}\n\n.cb-pk-append-after-hybrid,\n.cb-pk-append-after-error {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.cb-pk-append-after-hybrid-icon,\n.cb-pk-append-after-error-icon {\n  width: 6rem;\n  margin: 1.2rem auto;\n}\n\n.cb-pk-append-after-hybrid-description,\n.cb-pk-append-after-error-description {\n  display: flex;\n  flex-direction: row;\n  gap: 0.7rem;\n  margin-bottom: 1.5rem;\n  width: 90%;\n  align-self: center;\n}\n\n.cb-pk-append-after-hybrid-description-icon,\n.cb-pk-append-after-error-description-icon {\n  height: 1.5rem;\n  margin: auto;\n  flex: 0 0 10%;\n  max-width: 10%;\n}\n\n.cb-pk-append-after-hybrid-button,\n.cb-pk-append-after-error-button {\n  display: flex;\n  flex-direction: column;\n  margin: 0.8rem auto;\n}\n\n.cb-login-init {\n  display: flex;\n  flex-direction: column;\n}\n\n.cb-social-login-divider {\n  margin: 0 0 0.75rem 0;\n}\n\n.cb-social-login-buttons-section {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: space-around;\n  width: var(--cb-container-wide-width);\n  align-self: center;\n  margin-bottom: 1rem;\n}\n\n.cb-social-login-buttons-section-large {\n  flex-direction: column;\n}\n\n.cb-social-login-buttons-section-small {\n  flex-direction: row;\n}\n\n.cb-social-login-buttton-large img {\n  height: 1.25rem;\n  padding-right: 0.25rem;\n}\n\n.cb-social-login-button-loading-spinner {\n  border-top-color: var(--cb-primary-color);\n  border-right-color: var(--cb-primary-color);\n  width: 0.9rem;\n  height: 0.9rem;\n}\n\n.cb-last-identifier {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  border-radius: var(--cb-border-radius-sm);\n  border: var(--cb-border-color) 1px solid;\n  margin: 0.75rem 0;\n  padding: 0.6rem 0.5rem 0.6rem 1rem;\n  align-self: center;\n  cursor: pointer;\n  width: var(--cb-container-standard-width);\n}\n\n.cb-last-identifier:hover {\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-last-identifier-disabled {\n  cursor: default;\n  background-color: var(--cb-box-color-hover);\n}\n\n.cb-last-identifier-icon {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n}\n\n.cb-last-identifier-icon img {\n  width: 2rem;\n  height: 2rem;\n}\n\n.cb-last-identifier-details {\n  flex: 5;\n  display: flex;\n  flex-direction: column;\n  justify-content: left;\n  line-height: normal;\n  gap: 0.35rem;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.cb-last-identifier-spinner {\n  border-top-color: var(--cb-text-primary-color);\n  border-right-color: var(--cb-text-primary-color);\n  border-left-color: var(--cb-text-primary-color);\n  width: 1.5rem;\n  height: 1.5rem;\n  box-sizing: border-box;\n}\n\n.cb-last-identifier-value-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cb-last-identifier-skip-button {\n  margin: 0.5rem auto 0.75rem auto;\n  width: var(--cb-container-wide-width);\n}\n\n@media screen and (max-width: 399px) {\n  .cb-pk-error-light-header {\n    width: var(--cb-container-standard-width);\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .cb-otp-input-container {\n    gap: 0.5rem;\n  }\n\n  .cb-otp-input {\n    height: 2.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
